import { render, staticRenderFns } from "./RequestHistoryActionReminder.vue?vue&type=template&id=021a3b00&scoped=true&"
import script from "./RequestHistoryActionReminder.vue?vue&type=script&lang=js&"
export * from "./RequestHistoryActionReminder.vue?vue&type=script&lang=js&"
import style0 from "./RequestHistoryActionReminder.vue?vue&type=style&index=0&id=021a3b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a3b00",
  null
  
)

component.options.__file = "RequestHistoryActionReminder.vue"
export default component.exports